<template>
	<div class="wish-board" ref="wishBoard">
		<h1>2020 WISH BOARD</h1>

		<masonry :cols="{default: 4, 920: 3, 575: 2}" :gutter="16" class="masonry-list">
			<template v-for="(prayer, index) in recentWishList">
				<wish-card v-if="!prayer.toggleAllWish" :show-toggle-button="true" :total-wish="prayer.totalWish" :item="prayer.randomWish" @toggle="prayer.toggleAllWish = true"></wish-card>
				<template v-else>
					<wish-card v-for="(wish, index) in prayer.wishes" :item="wish"></wish-card>
				</template>
			</template>
		</masonry>

		<center class="footer">
			<bouncing-dots :show="isFetching && !noMoreData"></bouncing-dots>
			<infinite-scroll v-if="!isFetching && !noMoreData" :show-button="true" :listening="!isFetching && !noMoreData" @fetch="handleInfinteScroll"></infinite-scroll>
		</center>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import BouncingDots from '@/components/BouncingDots.vue'
	import InfiniteScroll from '@/components/InfiniteScroll.vue'
	import WishCard from '@/components/WishCard.vue'

	export default {
		components: {
			BouncingDots,
			InfiniteScroll,
			WishCard
		},
		data () {
			return {
				page: 1,
				recentWishList: [],
				isFetching: false,
				noMoreData: true
			}
		},
		methods: {
			handleInfinteScroll () {
				this.fetchMoreResults()
			},
			fetchMoreResults () {
				if (this.isFetching) {
					return
				}

				this.isFetching = true
				this.noMoreData = false

				let url = `${config.BASE_URL}/wish/2020/recent?page=${this.page}`

				window.axios.get(url)
					.then((response) => {
						if (response.data.code == 0) {
							if (!response.data.data.length) {
								this.noMoreData = true
							} else {
								if (Array.isArray(response.data.data)) {
									response.data.data.forEach(wish => {
										wish.toggleAllWish = false
										this.recentWishList.push(wish)
									})
								}
								this.page++
							}

							this.isFetching = false
							if (response.data.data.length < 12) {
								this.noMoreData = true
							}
						} else {
							this.noMoreData = true
							this.isFetching = false
						}
					})
			},
		},
		mounted () {
			this.fetchMoreResults()
		}
	}
</script>

<style lang="scss">
	@mixin text-image-replacement {
	    text-indent: -3000px;
	    color: transparent;
	    background: center no-repeat transparent;
	    background-size: contain;
	}

	.wish-board {
		padding: 20px 1rem 50px;
		max-width: 960px;

		margin: 0 auto;
		
		@media (max-width: 767px) {
			padding-top: 10px;
		}

		h1 {
			@include text-image-replacement;
			background: url('../assets/text-2020-wishboard.png') center center no-repeat;
		    background-size: contain;
			width: 306px;
			height: 81.5px;
			line-height: 81.5px;

			margin: 0 auto;
		}

		.masonry-list {
			margin: 2.5rem 0 1rem;
		}

		.footer {
			display: flex;
			flex-flow: column;

			> div {
				width: 100%;
			}

			button {
				width: 100%;
				font-size: 20px;
				border-width: 1px;
				height: 38px;
			}
		}
	}
</style>